/* eslint-disable */ 
<template>
<ul class="pagination">
    <li 
      class="pagination-item page-item"
    >
      <button
       class="page-link" 
        type="button" 
        @click="onClickFirstPage"
        :disabled="isInFirstPage"
        aria-label="Go to first page"
      >
        First
      </button>
    </li>

    <li
      class="pagination-item page-item"
    >
      <button 
       class="page-link" 
        type="button" 
        @click="onClickPreviousPage"
        :disabled="isInFirstPage || totalPages === 0"
        aria-label="Go to previous page"
      >
        Previous
      </button>
    </li>
    <li v-for="page in pages" class="pagination-item page-item" v-bind:key="page.name">
      <button 
      class="page-link" 
        type="button" 
        @click="onClickPage(page.name)"
        :disabled="page.isDisabled"
        :class="{ active: isPageActive(page.name)}"
        :aria-label="`Go to page number ${page.name}`"
        
      >
        {{ page.name }}
      </button>
    </li>

    <li class="pagination-item page-item">
      <button
      class="page-link"  
        type="button" 
        @click="onClickNextPage"
        :disabled="isInLastPage || totalPages === 0"
        aria-label="Go to next page"
      >
        Next
      </button>
    </li>

    <li class="pagination-item page-item">
      <button 
      class="page-link" 
        type="button" 
        @click="onClickLastPage"
        :disabled="isInLastPage || totalPages === 0"
        aria-label="Go to last page"
      >
        Last
      </button>
    </li>
  </ul>
</template>

<style>

.pagination {
  list-style-type: none;
}

.page-link.active:hover {
   background-color: #2C3D47;
   color: white !important;
}

.page-link.active {
   background-color: #2C3D47;
   color: white !important;
}

</style>

<script>
/* eslint-disable */
import axios from 'axios'
export default {
    props: {
        maxVisibleButtons: {
            type: Number,
            required: false,
            default: 5
        },
        totalPages: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            required: true
        },
        perPage: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
    },
    data() {
      return {
        email : '',
      }
    },
    computed: {
      startPage() {
          if (this.currentPage === 1) {
              return 1;
          }

          if (this.currentPage === this.totalPages) { 
            var firstPage = this.totalPages - this.maxVisibleButtons + 1;

            if (firstPage <= 0) {
              return 1;
            }
            else {
              return this.totalPages - this.maxVisibleButtons + 1;
            }     
          }

          if (this.currentPage - 1 === 0) {
            return this.currentPage;
          }

          return this.currentPage - 1;

      },
      endPage() { 
          return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
      },
      pages() {
        const range = [];

        for (let i = this.startPage; i <= this.endPage; i+= 1 ) {
          range.push({
            name: i,
            isDisabled: i === this.currentPage 
          });
        }

        return range;
      },
      isInFirstPage() {
          return this.currentPage === 1;
      },
      isInLastPage() {
          return this.currentPage === this.totalPages;
      },
  },
    methods: {
        onClickFirstPage() {
            this.$emit('pagechanged', 1);
        },
        onClickPreviousPage() {
            this.$emit('pagechanged', this.currentPage - 1);
        },
        onClickPage(page) {
            this.$emit('pagechanged', page);
        },
        onClickNextPage() {
            this.$emit('pagechanged', this.currentPage + 1);
        },
        onClickLastPage() {
            this.$emit('pagechanged', this.totalPages);    
        },
        isPageActive(page) {
            return this.currentPage === page;
        },
    }
}
</script>